import {AdvancedMarker} from "@vis.gl/react-google-maps";
import pinTaxiWhite from "@/assets/icons/icon-pin-taxi-white.png";
import type {DriverData} from "../utils/types";
import styles from "./DriverMarkers.module.css";

type DriverMarkersProps = {
    drivers: DriverData[];
    zoom: number;
};

export function DriverMarkers({drivers, zoom}: DriverMarkersProps) {
    return (
        <>
            {drivers.map((driver) => {
                const markerZoomFactor = Math.max(0.7, (zoom - 10) / 5);
                const markerBaseHeight = 32;
                const markerHeight = markerBaseHeight * markerZoomFactor;

                const markerStyle = {
                    transform: `rotate(${driver.bearing}deg)`,
                    height: `${markerHeight}px`,
                    position: "relative" as const,
                    top: `${markerHeight / 2}px`,
                };

                return (
                    <AdvancedMarker
                        key={driver.id}
                        position={{lat: driver.lat, lng: driver.lon}}
                        zIndex={0}
                    >
                        <div className={styles.marker} style={markerStyle}>
                            <img height="100%" src={pinTaxiWhite} alt="" />
                        </div>
                    </AdvancedMarker>
                );
            })}
        </>
    );
}
